{
  "name": "datazauta-frontend",
  "version": "4.5.2",
  "private": true,
  "scripts": {
    "dev": "ng serve",
    "build": "ng build",
    "build:watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "i18n:extract": "ng extract-i18n --output-path src/locale",
    "gen:api-client": "npx openapi-typescript-codegen --input https://api.datazauta.cz/v1/definition/ --output ./src/api --client angular",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org infologic-sro --project dza-portal ./dist && sentry-cli sourcemaps upload --org infologic-sro --project dza-portal ./dist"
  },
  "dependencies": {
    "@angular-slider/ngx-slider": "^22.0.0",
    "@angular/cdk": "^22.2.1",
    "@angular/common": "^22.2.1",
    "@angular/compiler": "^22.2.1",
    "@angular/core": "^22.2.1",
    "@angular/forms": "^22.2.1",
    "@angular/google-maps": "^22.2.1",
    "@angular/material": "^22.2.1",
    "@angular/material-moment-adapter": "^22.2.1",
    "@angular/platform-browser": "^22.2.1",
    "@angular/router": "^22.2.1",
    "@sentry/angular": "^11.5.0",
    "angular-highcharts": "^22.0.7",
    "bootstrap": "^5.3.8",
    "diacritics": "^1.3.0",
    "highcharts": "^13.1.1",
    "hls.js": "^1.7.3",
    "moment": "^2.31.0",
    "moment-timezone": "^0.6.5",
    "ngx-bootstrap": "^22.0.0",
    "ngx-image-cropper": "^9.1.7",
    "ngx-order-pipe": "^3.0.0",
    "rxjs": "^7.8.2"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^22.5.0",
    "@angular-eslint/eslint-plugin": "^22.5.0",
    "@angular-eslint/eslint-plugin-template": "^22.5.0",
    "@angular-eslint/schematics": "^22.5.0",
    "@angular-eslint/template-parser": "^22.5.0",
    "@angular/build": "^22.2.2",
    "@angular/cli": "^22.2.2",
    "@angular/compiler-cli": "^22.2.1",
    "@angular/localize": "^22.2.1",
    "@eslint/js": "^10.0.1",
    "@sentry/cli": "^3.8.0",
    "@types/diacritics": "^1.3.3",
    "@types/node": "^24.19.1",
    "angular-eslint": "22.5.0",
    "eslint": "^10.12.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-import-resolver-typescript": "^4.4.5",
    "eslint-plugin-import-x": "^4.17.1",
    "eslint-plugin-prettier": "^5.5.6",
    "jsdom": "^30.1.2",
    "openapi-typescript-codegen": "~0.31.0",
    "prettier": "^3.9.9",
    "tslib": "^2.8.1",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.71.1",
    "vitest": "^5.0.3"
  }
}
